import { LANGUAGE_CODE } from "consts";

export const LANGUAGES = [
  {
    language: "Zulu (dev)",
    code: LANGUAGE_CODE.ZULU,
    development: true,
    showOnAdmin: false,
  },
  {
    language: "Deutsch",
    code: LANGUAGE_CODE.GERMAN,
    development: false,
    showOnAdmin: true,
  },
  {
    language: "English",
    code: LANGUAGE_CODE.ENGLISH,
    development: false,
    showOnAdmin: true,
  },
  {
    language: "English (UK)",
    code: LANGUAGE_CODE.ENGLISH_GB,
    development: false,
    showOnAdmin: true,
  },
  {
    language: "Čeština",
    code: LANGUAGE_CODE.CZECH,
    development: false,
    showOnAdmin: true,
  },
  {
    language: "Polski",
    code: LANGUAGE_CODE.POLISH,
    development: false,
    showOnAdmin: true,
  },
  {
    language: "Magyar",
    code: LANGUAGE_CODE.HUNGARIAN,
    development: false,
    showOnAdmin: true,
  },
  {
    language: "Slovenský",
    code: LANGUAGE_CODE.SLOVAK,
    development: true,
    showOnAdmin: true,
  },
  {
    language: "English (US)",
    code: LANGUAGE_CODE.ENGLISH_US,
    development: true,
    showOnAdmin: true,
  },
  // this language is only used for in-context-localization for crowdin
  {
    language: "Acholi",
    code: LANGUAGE_CODE.ACHOLI,
    development: true,
    showOnAdmin: false,
  },
];
